
export default {
  black: {
    color100: "rgba(255, 255, 255, 1)",
    color086: "rgba(255, 255, 255, 0.86)",
    color030: "rgba(255, 255, 255, 0.30)",

    lineColor: "rgba(255, 255, 255, 0.16)",
    dotColor: "rgba(138, 144, 177, 1)",
    poiActiveColor: "rgba(141, 141, 255, 1)",
    poiTextActiveColor: "rgba(255, 255, 255, 1)",

    moreBtnBg: "rgba(255, 255, 255, 0.16)",
    bgOpacity: 0.2
  },
  white: {
    color100: "rgba(1, 9, 26,  1)",
    color086: "rgba(1, 9, 26, 0.86)",
    color030: "rgba(1, 9, 26, 0.30)",

    lineColor: "rgba(255, 255, 255, 0.16)",
    dotColor: "rgba(138, 144, 177, 1)",
    poiActiveColor: "rgba(113, 137, 196, 1)",
    poiTextActiveColor: "rgba(255, 255, 255, 1)",

    moreBtnBg: "rgba(255, 255, 255, 0.4)",
    bgOpacity: 0.4
  }
}


